import React from "react";
import ReactDOM from "react-dom";
import PollsWidget from "./Modules/Homepage/Polls/PollsWidget";
import { Provider } from "react-redux";
import { globalRootStore} from "./Redux/GlobalRootStore";

const mountElement = (element, Component) => {
    const resolvedElements = document.getElementsByClassName(element);

    if (resolvedElements.length > 0) {
        for (let i = 0; i < resolvedElements.length; i++) {
            const mobileComponent = 0;
            const desktopComponent = 1;

            if (i === mobileComponent) {
                if (window.innerWidth > 852) {
                    continue;
                }
            } 

            if (i === desktopComponent) {
                if (window.innerWidth < 852) {
                    continue;
                }
            }
            ReactDOM.render(Component, resolvedElements[i]);
        }
    }
};

mountElement(
    "PollsWidget",
    <Provider store={globalRootStore}>
        <PollsWidget className="PollsWidget" />
    </Provider>
);
